import React from "react";

const Work = () => {
  return (
    <section className="work" id="work">
      <div className="container pt-8">
        <div className="about-me-text mt-5 text-center position-relative">
          <h1 className="position-absolute know-text">My Work</h1>
          <h1 className="about-me-txt text-muted">portfolio</h1>
        </div>

        {/* <div className="row mt-5">
          <div className="col-md-4">
            <div className="card" >
              <img src="images/card.png" className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title">Card title</h5>
                <p className="card-text">
                  Some quick example text to build on the card title and make up
                  the bulk of the card's content.
                </p>
                <a href="#" className="btn btn-primary">
                  Go somewhere
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card" >
              <img src="images/card.png" className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title">Card title</h5>
                <p className="card-text">
                  Some quick example text to build on the card title and make up
                  the bulk of the card's content.
                </p>
                <a href="#" className="btn btn-primary">
                  Go somewhere
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card" >
              <img src="images/card.png" className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title">Card title</h5>
                <p className="card-text">
                  Some quick example text to build on the card title and make up
                  the bulk of the card's content.
                </p>
                <a href="#" className="btn btn-primary">
                  Go somewhere
                </a>
              </div>
            </div>
          </div>
        </div> */}

        <main className="page-content">
          <div className="d_card">
            <a href="https://afeef-calculator-app.netlify.app/" target="_blank">
              <div className="content">
                <h2 className="heading">Calculator App</h2>
                <p className="data-content">
                  "Developed and deployed a React-based calculator app
                  showcasing strong frontend development skills."{" "}
                  <span className="click">Click For Preview</span>
                </p>
              </div>
            </a>
          </div>
          <div className="d_card">
            <a
              href="https://64b6d6d74573c80096fed08e--crypto-coins-app-afeef.netlify.app/"
              target="_blank"
            >
              <div className="content">
                <h2 className="heading">Crypto App</h2>
                <p className="data-content">
                  Built secure React app, leveraging API data for real-time
                  crypto tracking{" "}
                  <span className="click">Click For Preview</span>
                </p>
              </div>
            </a>
          </div>
          <div className="d_card">
            <a
              href="https://afeef03.github.io/asimcattery.github.io/"
              target="_blank"
            >
              <div className="content">
                <h2 className="heading">Asim Cattery</h2>
                <p className="data-content">
                  Created a pet cattery website using React JS and Bootstrap{" "}
                  <span className="click">Click For Preview</span>
                </p>
              </div>
            </a>
          </div>
          <div className="d_card">
            <a href="/">
              <div className="content">
                <h2 className="heading">Portfolio Website</h2>
                <p className="data-content">
                  Developed and Deployed portfolio website using React JS and
                  Bootstrap
                  <span className="click">Click For Preview</span>
                </p>
              </div>
            </a>
          </div>
        </main>
      </div>
    </section>
  );
};

export default Work;
